module.exports = __webpack_public_path__ + "static/media/Rect1.bacd79f1.svg";